import { IconsDirective } from '@awork/_shared/directives/icons/icons.directive'
import { Component, computed, input } from '@angular/core'

let nextId = 0

/**
 * Figma "Content block": an optional section label above a rounded card that groups content items.
 */
@Component({
  selector: 'aw-content-block',
  templateUrl: './content-block.component.html',
  styleUrl: './content-block.component.scss',
  imports: [IconsDirective]
})
export class ContentBlockComponent {
  readonly label = input<string>()
  readonly icon = input<string>()

  protected readonly labelId = `content-block-label-${nextId++}`
  protected readonly labelledBy = computed(() => (this.label() ? this.labelId : null))
}
